import { useMutation } from "@tanstack/react-query";
import { UserAddParams, userAdd } from "common/api/citajteo/citajteo_user";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseUserAddParams = {
  invalidateKeys?: string[];
  successHandle?: Function;
  errorHandle?: Function;
};

export const useUserAdd = (hookParams?: UseUserAddParams) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: userAddMutate } = useMutation({
    mutationFn: async (userAddParams: UserAddParams) => {
      const response = (await userAdd(userAddParams)) as string | null;
      console.log("useUserAdd - response", response);
      return response;
    },
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }

      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
    onError: (error) => {
      if (hookParams?.errorHandle) {
        hookParams.errorHandle(error);
      }
    },
  });

  return { userAddMutate };
};
